// 全局请求对象
// eslint-disable-next-line import/no-mutable-exports
let request = {
    get: () => { },
    post: () => { },
};
// eslint-disable-next-line import/no-mutable-exports
let requestOptions = {
    lang: '',
};
/**
 * 设置请求对象
 * @category global
 * @param requestFn 传入的请求方法
 */
const setRequest = (requestFn, options) => {
    if (!requestFn)
        throw new Error('setRequest方法入参不为空');
    request = adaptRequest(requestFn);
    requestOptions = Object.assign(Object.assign({}, requestOptions), options);
    console.log('@tencent/wphk-act-base-cgi:初始化成功！');
};
const adaptRequest = (request) => {
    const _request = request;
    // 这里目前只支持传入base-lib的request,没有对wphk-act-base-api的request做兼容
    if (!request) {
        throw new Error('传入request不能为空');
    }
    return _request;
};
export { request, setRequest, requestOptions };
